import { render } from "./accountButton.vue?vue&type=template&id=6e9408fd&scoped=true&ts=true"
import script from "./accountButton.vue?vue&type=script&lang=ts"
export * from "./accountButton.vue?vue&type=script&lang=ts"

import "./accountButton.vue?vue&type=style&index=0&id=6e9408fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9408fd"],['__file',"src/components/account/accountButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e9408fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e9408fd', __exports__)) {
    api.reload('6e9408fd', __exports__)
  }
  
  module.hot.accept("./accountButton.vue?vue&type=template&id=6e9408fd&scoped=true&ts=true", () => {
    api.rerender('6e9408fd', render)
  })

}


export default __exports__